{
  "pt": {
    "published": {
      "labels": {
        "notPublished": "Não publicado",
        "publishedCustomer": "Publicado para clientes",
        "publishedCustomerPartners": "Publicado para clientes e parceiros",
        "publishedPartners": "Publicado para parceiros"
      },
      "publish_mode": {
        "inherit": "Seguir o modelo",
        "inherit_info": "Manter o estado publicado ou não publicado de cada item do modelo"
      }
    }
  }
}
